const state = {
    data: {}
}

const getters = {
    getDataConnectLine() {
        return state.data;
    }
}

const mutations = {
    async setDataConnectLine(data) {
        const dataEvent = data.split('||');
        state.data = {
            queue: dataEvent[0],
            name: dataEvent[1],
            phone: dataEvent[1],
            protocol: dataEvent[2],
            type: 'phone'
        }

        return state.data;
    },

    async delDataConnectLine() {
        state.data = {}
    },

    async setChatData(data) {
        state.data = {
            protocol: data.protocol,
            phone: data.phone,
            type: data.channel || "chat",
            name: data.name,
            queue: (data.queue === 'SAC') ? 'Vendedor' : data.queue,
            cpd: data.cpd || data.cod_cliente|| '',
            clientPhone: data.phone?.replace('@s.whatsapp.net', '') || '',
            nomeURA: data.cliente_nome|| '',
            razaoSocial: data.nom_cliente || '',
            sessionDate: data.sessionDate || null,
            cpdnovo: data.cod_cliente|| '',
            email: data.email || data.dados_email || '',
        };

        return state.data;
    }
}

export default {
    state,
    getters,
    mutations
}
